<div class="mtm-text-editor" [ngClass]="{ expandable: expandable }">
  <div class="w-100" [ngClass]="{ 'd-flex': userAvatar }">
    @if (userAvatar) {
      <mtm-user-profile-picture
        [username]="userAvatar"
        [height]="28"
        [width]="28"
        [fontSize]="'10px'"
        [forceLoadProfile]="true"
        class="pt-2 ps-2">
      </mtm-user-profile-picture>
    }
    <quill-editor
      id="{{ elementId }}"
      class="d-block w-100"
      [(ngModel)]="value"
      [customModules]="quillCustomModules"
      (onEditorCreated)="onEditorInitialized($event)"
      (onContentChanged)="textChanged($event)"
      [placeholder]="placeholder | translate"
      [modules]="quillModule"
      #editor></quill-editor>
  </div>
  @if (isEmojiPickerVisible) {
    <emoji-mart
      class="emoji-mart mt-2"
      (emojiSelect)="addEmoji($event)"
      [darkMode]="false"
      style="border: 1px solid #d9d9d9 !important; border-radius: 5px">
    </emoji-mart>
  }
</div>
<div class="upload-toolbar" [hidden]="!showBottomToolbar">
  @if (attachments?.length) {
    <div
      class="d-flex align-items-center text-center mt-2 flex-wrap"
      [style.margin-left]="'-8px'"
      [style.margin-right]="'-8px'">
      @for (attachment of attachments; track attachment) {
        <div class="d-flex text-center pointer file-content ms-2 me-2 mb-2" [style.position]="'relative'">
          <hr-badgebtn-subcmp
            [file]="attachment"
            [isDisplayTrashBtn]="true"
            (onTrashFile)="deleteFile(attachment)"></hr-badgebtn-subcmp>
          <hr-grid-subcmp
            [file]="attachment"
            [compactView]="true"
            [hideDeleteButton]="true"
            class="w-100"></hr-grid-subcmp>
        </div>
      }
    </div>
  }
  <div class="file-upload-icon d-flex align-items-center me-3">
    <div class="file-icon-wrapper">
      <i class="fa fa-plus p-2" [title]="'Add file(s)'" (click)="openFileExplorer()"></i>
      @if (files?.length) {
        <span [title]="`${files.length} file(s)`" class="file-display-thumbnail">
          <div
            ngbDropdown
            [autoClose]="true"
            class="file-dropdown-component d-flex align-items-center"
            container="body"
            #dropdownFiles>
            <button type="button" class="d-flex align-items-center btn" ngbDropdownToggle>
              <span class="text-uppercase">
                {{ files?.length }}
              </span>
            </button>
            <div ngbDropdownMenu class="file-item-list">
              <div class="d-flex flex-column">
                @for (file of files; track file) {
                  <div class="d-flex text-center pointer file-content m-2" [style.position]="'relative'">
                    <hr-badgebtn-subcmp
                      [file]="file"
                      [isDisplayTrashBtn]="true"
                      [localFile]="true"
                      (onTrashFile)="deleteFile(file)"></hr-badgebtn-subcmp>
                    <hr-grid-subcmp
                      [file]="file"
                      [compactView]="true"
                      [hideDeleteButton]="true"
                      class="w-100"></hr-grid-subcmp>
                  </div>
                }
              </div>
            </div>
          </div>
        </span>
      }
    </div>
  </div>
  <div class="upload-file-container" [hidden]="true">
    <mtm-upload-file
      [isRoundedCircle]="false"
      [isRedirectImageLoadError]="false"
      (files)="fileChangeListener($event)"
      #mtmUploadFileExplorer>
    </mtm-upload-file>
  </div>
</div>
